//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'ArticleCard',
    props: {
        slug: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        lead: {
            type: String,
            required: true,
        },
        image: {
            type: String,
            required: true,
        },
    },
};
